import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { PageWrapper, BackBtn } from '../../components/layout/content';

import { URL } from '../../constants';
import { isEmpty } from '../../utils';

import DadJokesPanel from './components/dadJokesPanel';
import DownloadPanel from './components/downloadPanel';
import EventDetailsPanel from './components/eventDetailsPanel';
import { getEvents } from './components/getData';
import NotePanel from './components/notePanel';
import PaymentPanel from './components/paymentPanel';
import UgcUploadPanel from './components/ugcUploadPanel';
import VideoPanels from './components/videoPanels';

const AttendeeEvent = () => {
  const { eventId = '' } = useParams();

  const navigate = useNavigate();

  const event = getEvents().find((event) => event.eventId === eventId);

  const [isCreationPaid, setIsCreationPaid] = useState(
    event?.isCreationPaid ?? false,
  );
  const [isClipsPaid, setIsClipsPaid] = useState(event?.isClipsPaid ?? false);

  if (!event || isEmpty(event)) {
    navigate(URL.ATTENDEE_PORTAL);
    return;
  }

  const isCreationAccess = (event.payment?.paid || isCreationPaid) ?? false;
  const isClipsAccess = isClipsPaid ?? false;

  const isComplete = event.stage === 'Generation';

  return (
    <PageWrapper type="header-only" title={event.name}>
      <BackBtn
        onClick={() => navigate(URL.ATTENDEE_PORTAL)}
        label="Back to Events"
      />

      <div className="flex flex-col gap-10">
        <div className="flex gap-10">
          <EventDetailsPanel event={event} />

          {!isComplete && <NotePanel event={event} />}

          <PaymentPanel
            event={event}
            isCreationPaid={isCreationPaid}
            isClipsPaid={isClipsPaid}
            setIsCreationPaid={setIsCreationPaid}
            setIsClipsPaid={setIsClipsPaid}
            isCreationAccess={isCreationAccess}
            isClipsAccess={isClipsAccess}
          />

          {isComplete && (
            <DownloadPanel
              isCreationAccess={isCreationAccess}
              isClipsAccess={isClipsAccess}
            />
          )}
        </div>

        {isComplete ? (
          <VideoPanels
            event={event}
            isCreationAccess={isCreationAccess}
            isClipsAccess={isClipsAccess}
          />
        ) : event.stage === 'Analysis' && isEmpty(event.clips) ? (
          <UgcUploadPanel event={event} />
        ) : (
          <DadJokesPanel />
        )}
      </div>
    </PageWrapper>
  );
};

export default AttendeeEvent;
